module.exports = __webpack_public_path__ + "media/images/front/icon_check_01-50a4a6f1823ed34a309541bb3ee2c4dd.svg";